// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DSnA","clinicsSelect":"styles_clinicsSelect__3pc5d"};